// Highlights the matching sidebar link as the user scrolls through resource sections.
export default function initResourcePage() {
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-resource-page]').forEach((page) => {
        const links = page.querySelectorAll('[data-toc-link]');
        const sections = page.querySelectorAll('[data-toc-section]');
        if (!links.length || !sections.length) return;

        const setActive = (id) => {
            links.forEach((a) => {
                a.classList.toggle('is-current', a.getAttribute('data-toc-link') === id);
            });
        };

        const ratios = new Map();

        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                ratios.set(e.target.getAttribute('data-toc-section'), e.intersectionRatio);
            });
            let best = { id: null, ratio: 0 };
            ratios.forEach((ratio, id) => {
                if (ratio > best.ratio) best = { id, ratio };
            });
            if (best.id) setActive(best.id);
        }, {
            threshold: [0, 0.25, 0.5, 0.75, 1],
            rootMargin: '-30% 0px -50% 0px',
        });

        sections.forEach((s) => io.observe(s));
    });
}
